import { Component, OnInit, OnDestroy, ViewChild} from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Observable, Subscription } from 'rxjs';
import { BusinessProcessService } from '../../../../services/business-process.service';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { AdminService } from '../../../../services/admin.service';
import { Group } from '../../../../Models/group';
import { take } from 'rxjs/operators';
import { CheckboxListComponent, ICheckboxListSettings} from '../../../../common/checkbox-list/checkbox-list.component';

@Component({
  selector: 'app-history-report-visibility',
  templateUrl: './history-report-visibility.component.html',
  styleUrls: ['./history-report-visibility.component.css', '../../../../styles/business-process-configuration.css']
})
export class HistoryReportVisibilityComponent implements OnInit, OnDestroy {

  @ViewChild(CheckboxListComponent, { static: false }) checkboxListComponent: CheckboxListComponent;

  constructor(
    private route: ActivatedRoute,
    private bpService: BusinessProcessService,
    private formBuilder: FormBuilder,
    private admService: AdminService
  ) { }

  get formData() {
    return this.form.controls;
  }

  form: FormGroup;

  fieldsData = [];
  existingFieldsConfig = [];
  existingStatesConfig = [];
  statesData = [];
  groupsWithConfigs = [];
  selectedFields = [];
  selectedStates = [];

  fieldListSettings: ICheckboxListSettings;
  stateListSettings: ICheckboxListSettings;

  errorMessage = '';
  successMessage = '';
  submitClick = false;

  bpId: number;
  bpName: string;
  bpDescription: string;
  inscription: Subscription;
  groupList: Observable<Group[]>;

  ngOnInit() {
    this.inscription = this.route.params.subscribe(
      params => {
        this.bpId = params['id'];
      }
    );

    this.initializeForm();

    if (!isNaN(parseFloat(this.bpId.toString()))) {
      this.bpService.getPublishedFieldsByBusinessProcessId(this.bpId)
        .subscribe( fields => {
          this.fieldsData = fields;
          this.setFieldListSettings();
        });

      this.bpService.getPublishedBusinessProcessById(this.bpId)
        .subscribe( businessProcess => {
          this.bpName = businessProcess.name;
          this.bpDescription = businessProcess.description;
          this.bpService.getStatesByBusinessProcessSpecificVersion(this.bpId, businessProcess.version)
            .subscribe( result => {
              this.statesData = result;
              this.setStateListSettings();
            }, error1 => {
              this.errorMessage = error1;
              console.error(error1);
            });
        }, error1 => {
          this.errorMessage = error1;
          console.error(error1);
        });
      this.checkGroupsWithConfigs();
      this.loadGroups();
    } else {
      this.errorMessage = 'Erro: Não foi possível recuperar as informações para o valor informado.';
    }
  }

  onSubmit() {
    this.submitClick = true;
    this.errorMessage = '';

    const newConfig: NewConfiguration = {
      businessProcessId: this.bpId,
      groupId: this.form.controls.groupId.value,
      visibleFieldIds: this.selectedFields,
      visibleStateIds: this.selectedStates,
    };

    this.bpService.createHistoryReportViewConfig(newConfig)
      .pipe(take(1))
      .subscribe( resp => {
        this.checkGroupsWithConfigs();
        this.submitClick = true;
        this.successMessage = this.checkPreviousConfig(this.form.controls.groupId.value) ?
          'Configuração atualizada com sucesso.' : 'Configuração criada com sucesso.';
        setTimeout(() => { this.submitClick = false; this.successMessage = ''; }, 2500);
      }, error1 => {
        this.errorMessage = this.extractErrorMessage(error1);
        this.submitClick = false;
      });
  }

  loadGroups() {
    this.groupList = this.admService.loadGroupList();
  }

  checkGroupsWithConfigs() {
    this.errorMessage = '';
    this.bpService.getHistoryReportViewConfigurations(this.bpId)
      .subscribe( configs => {
        this.groupsWithConfigs = configs.map( config => config.groupId);
      }, error1 => this.errorMessage = error1);
  }

  initializeForm() {
    this.form = this.formBuilder.group({
      groupId: [0, this.validateGroup],
    });
  }

  onGroupChange(element) {
    if (element.target.value == 0) {
      document.getElementById('groups').classList.add('is-invalid');
      this.submitClick = true;
    } else {
      document.getElementById('groups').classList.remove('is-invalid');
      this.submitClick = false;
    }
    this.errorMessage = '';
    if (element.target.value !== null) {
      this.bpService.getHistoryReportViewConfigurations(this.bpId)
        .subscribe( configs => {
          this.existingFieldsConfig = configs.filter(config => config.groupId == element.target.value)
            .map(config => config.visibleFieldIds)[0];
          this.selectedFields = this.existingFieldsConfig;
          this.existingStatesConfig = configs.filter(config => config.groupId == element.target.value)
            .map(config => config.visibleStateIds)[0];
          this.selectedStates = this.existingStatesConfig;
        }, error1 => {
          this.errorMessage = error1;
          document.getElementById('btnBack').focus();
        });
    }
  }

  onDelete() {
    this.submitClick = true;
    this.errorMessage = '';
    this.bpService.deleteHistoryReportViewConfiguration(this.bpId, Number(this.form.controls.groupId.value))
      .subscribe( success => {
        this.submitClick = true;
        this.successMessage = 'A configuração de visualização para o grupo selecionado foi excluída.';
        setTimeout(() => { this.submitClick = false; this.successMessage = ''; this.ngOnInit(); }, 2500);
      }, error => {
        this.errorMessage = error;
        this.submitClick = false;
      });
  }

  validateGroup(input: FormControl) {
    return input.value === 0 ? { emptyGroup: true } : null;
  }

  checkPreviousConfig(groupId: string) {
    return this.groupsWithConfigs.indexOf(Number(groupId)) > -1;
  }

  extractErrorMessage(error1: any) {
    let res = '';
    if (error1 != null) {
      if (error1.includes('não existe') && error1.includes('campo')) {
        res = this.extractNamesFromErrorMessage(error1, 'field', this.fieldsData);
      } else if (error1.includes('não existe') && error1.includes('estado')) {
        res = this.extractNamesFromErrorMessage(error1, 'state', this.statesData);
      }
    }
    return (res !== '' ? res : error1);
  }

   // Types = field or state // itens = array de fields ou array de estados
  extractNamesFromErrorMessage(errorMessage: string, type: string, items: any[]) {
    const names = [];
    let name = '';
    const messages = errorMessage.match(/(ID=\d+)+/g);
    messages.forEach(message => {
      const id = message.match(/(\d)+/);
      items.forEach( item => {
        if (type === 'field' && item.fieldId === Number(id[0])) {
          name = item.name;
        }
        if (type === 'state' && item.stateId === Number(id[0])) {
          name = item.name;
        }
      });
      if (name !== '') {
        names.push(name);
      } else {
        names.push(message);
      }
    });
    return 'Os seguintes ' + (type === 'field' ? 'campos' : 'estados') + ' não existem ou foram excluídos: ' +
                  names.join(', ');
  }

  ngOnDestroy() {
    this.inscription.unsubscribe();
  }

  getSelectedFields(element) {
    this.selectedFields = element;
  }

  getSelectedStates(element) {
    this.selectedStates = element;
  }

  setFieldListSettings() {
    this.fieldListSettings = {
      height: 250,
      idPropertyName: 'fieldId',
      namePropertyName: 'name',
      listTitle: 'Visibilidade de campos',
      inputSearchId: 'inputSearchFields',
      listOf: 'field'
    };
  }

  setStateListSettings() {
    this.stateListSettings = {
      height: 250,
      idPropertyName: 'stateId',
      namePropertyName: 'name',
      listTitle: 'Visibilidade de estados',
      inputSearchId: 'inputSearchStates',
      listOf: 'state'
    };
  }

}

export interface NewConfiguration {
  businessProcessId: number;
  groupId: number;
  visibleFieldIds: any[];
  visibleStateIds: any[];
}
